import Button from '../../Button/Button';
import styles from './SelectedDateModal.module.scss';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { setCurrentStep } from '../../../redux/modules/applicationData/applicationData.module';
import { useDispatch } from 'react-redux';
import {
  stepNavigationEdit,
  TAX_WITHHOLDING_STEP,
} from '../../../settings/settings';

const SelectedDateModal = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={styles['selected_date_modal_container']}>
      <div className={styles['selected_date_modal_container-body']}>
        <h1 className={styles['selected_date_modal_container-body_primary']}>
          You have selected a date that has passed for the current year
        </h1>
        <p className={styles['selected_date_modal_container-body_secondary']}>
          This may prevent your RMD from being satisfied for the current year.
        </p>
      </div>
      <div
        className={styles['selected_date_modal_container-footer-actionButtons']}
      >
        <Button onClick={() => props.onClose()}>Edit my selection</Button>
        <Button
          type="primary"
          onClick={() => {
            props.onClose();
            dispatch(setCurrentStep(TAX_WITHHOLDING_STEP));
            props.history.push(stepNavigationEdit[TAX_WITHHOLDING_STEP].step);
          }}
        >
          Continue with my selection
        </Button>
      </div>
    </div>
  );
};
export default compose(withRouter)(SelectedDateModal);
